// extracted by mini-css-extract-plugin
export default {"countdown":"A3-z","srOnly":"B3-z"};